import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import { Typography, Box, LinearProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function SuccessPage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/categories');
    }, 5000);

    const countdownInterval = setInterval(() => {
      setCountdown((prevCount) => prevCount - 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  return (
    <Container
      id="payment-success"
      sx={{
        pt: { xs: 12, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
        flexGrow: 1
      }}>
      <div className="min-h-screen flex items-center justify-center bg-green-50">
        <div className="text-center p-6 bg-white rounded-2xl shadow-lg max-w-md">
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CheckCircleIcon sx={{ fontSize: 64, color: 'green' }} />
          </Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{ mt: 2, fontWeight: 'bold', color: 'green.700' }}>
            Payment Successful!
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
            Thank you for your purchase. Your subscription is now active.
          </Typography>

          <Box sx={{ width: '100%', mt: 4 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Redirecting to cases in {countdown} seconds...
            </Typography>
            <LinearProgress variant="determinate" value={(5 - countdown) * 20} />
          </Box>
        </div>
      </div>
    </Container>
  );
}
